import { useTranslation } from "react-i18next";
import { Button, Stack, Title, Text, CopyButton, ActionIcon, Tooltip, Group, Box, Center } from "@mantine/core";
import { IconBrandApple, IconBrandGooglePlay, IconCopy, IconCheck, IconDeviceMobileMessage } from "@tabler/icons-react";

export const StepMobileHandoff = () => {
  const { t } = useTranslation();
  const currentUrl = window.location.href;

  return (
    <Stack align="center" py="xl" gap="lg">
      <Center>
        <Group justify="center" bg="blue.0" w={80} h={80} style={{ borderRadius: "100%" }}>
          <IconDeviceMobileMessage size={40} color="var(--mantine-color-blue-6)" />
        </Group>
      </Center>
      
      <Title order={3} ta="center">{t("onboarding-switch-app")}</Title>
      
      <Text ta="center" c="dimmed" size="sm">
        {t("onboarding-mobile-handoff-desc")}
      </Text>

      <Text ta="center" fw={500} c="blue.7" size="sm" mt="-sm">
        {t("onboarding-mobile-login-hint", "You can log in to the app using the email and password you just created.")}
      </Text>

      <Stack w="100%" gap="sm" mt="md">
        <Button 
          component="a" 
          href="https://apps.apple.com/gh/app/la-ruche-pro/id6749536771" 
          target="_blank" 
          size="lg" 
          color="dark" 
          leftSection={<IconBrandApple size={24} />}
        >
          {t("onboarding-download-app-store")}
        </Button>
        <Button 
          component="a" 
          href="https://play.google.com/store/apps/details?id=com.laruche_health.laruche_pro&pcampaignid=web_share" 
          target="_blank" 
          size="lg" 
          color="teal.7" 
          leftSection={<IconBrandGooglePlay size={24} />}
        >
          {t("onboarding-get-google-play")}
        </Button>
      </Stack>

      <Box mt="lg" w="100%">
        <Text size="sm" fw={500} mb="xs" ta="center">{t("onboarding-continue-computer")}</Text>
        <Group gap="xs" style={{ background: "#f8f9fa", padding: "12px", borderRadius: "8px", border: "1px solid #e9ecef" }} wrap="nowrap">
          <Text size="xs" c="dimmed" style={{ flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {currentUrl}
          </Text>
          <CopyButton value={currentUrl} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip label={copied ? 'Copied' : 'Copy link'} withArrow position="top">
                <ActionIcon color={copied ? 'teal' : 'gray'} variant="subtle" onClick={copy}>
                  {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
                </ActionIcon>
              </Tooltip>
            )}
          </CopyButton>
        </Group>
      </Box>
    </Stack>
  );
};
